import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleTwoToneIcon from '@mui/icons-material/PeopleTwoTone';
import BusinessTwoToneIcon from '@mui/icons-material/BusinessTwoTone';
import AnalyticsTwoToneIcon from '@mui/icons-material/AnalyticsTwoTone';
import DataUsageTwoToneIcon from '@mui/icons-material/DataUsageTwoTone';
import BuildTwoToneIcon from '@mui/icons-material/BuildTwoTone';
// import ManageAccountsTwoToneIcon from '@mui/icons-material/ManageAccountsTwoTone';
// import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
// import PaymentsTwoToneIcon from '@mui/icons-material/PaymentsTwoTone';
import TuneIcon from '@mui/icons-material/Tune';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';

const Menuitems = [
  {
    title: 'Dashboard',
    icon: DashboardOutlinedIcon,
    href: '/dashboard',
  },
  {
    title: 'Freelancers',
    icon: PeopleTwoToneIcon,
    href: '/freelancers',
  },
  {
    title: 'Clients',
    icon: BusinessTwoToneIcon,
    href: '/clients',
  },
  {
    title: 'Gig Management',
    icon: AnalyticsTwoToneIcon,
    href: '/gigs',
  },
  {
    title: 'Project Management',
    icon: DataUsageTwoToneIcon,
    href: '/projects',
  },
  {
    title: 'Operations',
    icon: AccountTreeTwoToneIcon,
    href: '/ops',
  },
  {
    title: 'Skills Management',
    icon: BuildTwoToneIcon,
    href: '/skills',
  },
  // {
  //   title: 'User Settings',
  //   icon: ManageAccountsTwoToneIcon,
  //   href: '/settings',
  // },
  // {
  //   title: 'Payments',
  //   icon: PaymentsTwoToneIcon,
  //   href: '/transactions',
  // },
  // {
  //   title: 'Invoices',
  //   icon: ReceiptTwoToneIcon,
  //   href: '/invoices',
  // },
];

export default Menuitems;
